import { AuthProvider, HttpError } from 'react-admin';
import SGXPermissions from '../auth/SGXPermissions';

import { sgxFetchApi, sgxFetchApiWithToken, jsonPayload } from './fetch';
import { UserIdentityDto, PermissionsDto, JWTokenDto } from './model';
import { clearTokens, retrieveToken, saveTokens } from './tokenStorage';

const GUEST_PERMISSIONS = new SGXPermissions({roleAssignments:[]});

const fetchPermissions = (): Promise<SGXPermissions> => sgxFetchApiWithToken<PermissionsDto>('account/permissions')
    .catch(e => GUEST_PERMISSIONS)
    .then(permissions => new SGXPermissions(permissions));

const authProvider: AuthProvider = {
    // authentication
    login: ({ username, password }) => {
        const options = jsonPayload('POST', { username, password });
        return sgxFetchApi<JWTokenDto>('auth', options)
            .then(({ token, refreshToken }) => {
                saveTokens(token, refreshToken);
            });
    },
    checkError: (error: HttpError) => {
        const status = error.status;
        if (status === 401 ) {
            clearTokens();
            return Promise.reject();
        }
        return Promise.resolve()
    },
    checkAuth: () => {
        return retrieveToken() ? Promise.resolve() : Promise.reject();
    },
    logout: () => {
        clearTokens();
        return Promise.resolve();
    },
    getIdentity: 
        () => sgxFetchApiWithToken<UserIdentityDto>('account/info'),
    // authorization
    getPermissions: _ => {
        return retrieveToken() ? fetchPermissions() : Promise.resolve(GUEST_PERMISSIONS);
    },
};

export default authProvider;
